<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">      
        <b-col md="8">           
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <form @submit.prevent="onSubmit">
                    <h2 class="text-dark">Login</h2>
                    <p class="text-muted">Sign In to your account</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                      <input type="text" v-model="username" class="form-control" placeholder="Username" autocomplete="username">
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                      <input type="password" v-model="password" class="form-control" placeholder="Password" autocomplete="current-password">
                    </b-input-group>
                    <b-row>
                      <b-col cols="6">
                        <!-- <b-button @click="goToHomePage" variant="primary" class="px-4">Login</b-button> -->
                        <b-button type="submit" variant="primary" class="px-4">Login</b-button>
                      </b-col>
                      <b-col cols="6" class="text-right">
                        <b-button variant="link" class="px-0">Forgot password?</b-button>
                      </b-col>
                    </b-row>
                </form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Sign up here if you need access to Deconfliction Notification System and you don't already have an account.</p>
                  <b-button variant="primary" @click="registerPage" class="active mt-3">Register</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
import axios from 'axios'

export default {
  name: 'Login',
  data () {
      return {
        username: '',
        password: ''
      }
  },    
  methods: {

    registerPage() {

      // redirect to login
      this.$router.push('/register')
    },

    onSubmit () {        
        this.$store.dispatch(types.ACTION_AUTH_USER, {username: this.username, password: this.password})
    }
  },
  mounted() {
    // console.log("DECON_API: "+ process.env.DECON_API)
  },

  created() {
    // clear local storage
    window.localStorage.clear()    
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue